module.exports = __webpack_public_path__ + "img/126.3.5faadfc3.png";